import axios from "axios";
// import { formatRM } from './formatters'
import { CANCEL } from "redux-saga";
import _ from "lodash";

// Import store to get access to state data - we'll use this to decide whether to fetch new rental data from the API
import store from "../store";

// Trakm8 is part of RouteMonkey.
const API_ROOT = "https://api-proj01.trakm8.net:8443/travelwest/latest/api/";
const API_KEY = "&apikey=tuVz2ioRpRbiv7iBH7P6m3PaVkBsjszA";

const CancelToken = axios.CancelToken;
let source;

function callAPI(query, modes) {
	query = API_ROOT + query + API_KEY;

	return new Promise((resolve, reject) => {
		axios
			.get(query, {
				cancelToken: source.token,
				timeout: 20000,
			})
			.then((response) => {
				// Check returned data
				if (response) {
					resolve(response);
				} else {
					reject("no posts");
				}
			})
			.catch((error) => {
				// Reject all but cancelled (as just discarded)
				if (!axios.isCancel(error)) {
					reject(error);
				}
			});
	});
}

export const getCycleHire = (options) => {
	const { hireComp } = options;
	let query;

	switch (hireComp) {
		case "cycleHire":
		case "yoBike":
			query = "locations/?layer=cycle_hire";
			break;
		default:
			query = null;
	}

	const promise = new Promise((resolve, reject) => {
		source = CancelToken.source();

		// Check whether state already has rental data for this rental type before calling the API
		const currentState = store.getState();

		// If data already in state, resolve the promise with it
		if (
			currentState.cycleHire.hireCompany &&
			currentState.cycleHire.hireCompany[hireComp]
		) {
			const markers =
				currentState.cycleHire.hireCompany[hireComp].results.markers;

			resolve({ markers });

			// Else, fetch the data from the API
		} else {
			callAPI(query)
				.then((response) => {
					let markers = response.data
						.map((single) => {
							let marker;

							// lowercase hirecompany and select only that company.
							let lowerHireComp = hireComp.toLowerCase();

							if (
								_.find(
									single.features,
									(feature) => feature.toLowerCase() === lowerHireComp
								)
							) {
								// Cycle hire provider
								let provider;
								if (
									_.find(
										single.features,
										(feature) => feature.toLowerCase() === "yobike"
									)
								) {
									provider = {
										icon: "pointer-yobike.png",
										link: {
											url: "https://yobike.com/",
											text: "Download the YoBike App",
										},
									};

									const location = {
										lat: single.geom.coordinates[1],
										lng: single.geom.coordinates[0],
									};
									const title = single.name;
									const content = `
								<h4 className="map-overlay-title">${ title }</h4>
								<p><a href="${ provider.link.url }"} target="_blank">${ provider.link.text } (Opens in new window)</a></p>
							`;
									const scale = 0.6;
									const icon_size = { width: 44, height: 56 };
									const icon_scaled_size = {
										width: icon_size.width * scale,
										height: icon_size.height * scale,
									};
									const icon_anchor = {
										x: icon_scaled_size.width / 2,
										y: icon_scaled_size.height,
									};
									const icon = {
										url: `${ window.ROOT }${ window.PORT }/images/markers/${ provider.icon }`,
										size: icon_size,
										scaledSize: icon_scaled_size,
										anchor: icon_anchor,
									};

									marker = {
										location,
										title,
										content,
										icon,
									};
								}
							} else {
								marker = null;
							}

							return marker;
						})
						.filter((marker) => marker !== null);

					resolve({ markers });
				})
				.catch((error) => {
					reject("Could not get rental.");
				});
		}
	});

	promise[CANCEL] = () => {
		source.cancel("Operation cancelled by the user.");
	};

	return promise;
};



// WEBPACK FOOTER //
// ./src/services/rm.js